import { Layout, LayoutProps, styled } from '@teko/ds-mobile';
import { logger } from '@teko/log';
import terraKit from '@terra-js/terra-kit';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

interface Props extends LayoutProps {
  /**
   * ExpandedNavBar is always show
   *  */
  expandedNavBar?: React.ReactNode;
  showBreadcrumb?: boolean;
  showTitle?: boolean;
}

export const MobileLayout: React.FunctionComponent<Props> = ({
  navbar,
  children,
  expandedNavBar,
  ...props
}: Props) => {
  const router = useRouter();
  const { query } = router;
  const [isSupportOmniApp, setSupportOmniApp] = useState(false);

  const hideHeader = !!query.hideHeader || !!query.supportOmniAppUI;

  /** setSupportOmniApp */
  useEffect(() => {
    try {
      (async () => {
        const res = await terraKit.erp().isSupportOmniApp(); // support in case redirect from landing page to landing page
        setSupportOmniApp(res);
      })();
    } catch (err) {
      logger(err);
    }
  }, []);

  return (
    <StyledLayout
      hideHeader={isSupportOmniApp || hideHeader}
      navbar={
        <React.Fragment>
          {hideHeader ? <HiddenNavBar>{navbar}</HiddenNavBar> : navbar}
          {expandedNavBar}
        </React.Fragment>
      }
      {...props}
    >
      {children}
    </StyledLayout>
  );
};

const HiddenNavBar = styled.div`
  display: none;
`;

const StyledLayout = styled(Layout)<{
  showBreadcrumb?: boolean;
  showTitle?: boolean;
  hideHeader?: boolean;
}>`
  .header-filter {
    top: ${({ showBreadcrumb, showTitle, hideHeader }) =>
      `${
        56 +
        // UX4BUYER-5506: Display Breadcrumbs for colelction page
        (showBreadcrumb ? 36 : 0) +
        // UX4BUYER-5504: add page title and quantity
        (showTitle ? 32 : 0) -
        // UX4BUYER-5790: hidden header
        (hideHeader ? 56 : 0)
      }px`};
    border-bottom: 1px solid ${({ theme }) => theme.colors.background};
  }
  .sort-bottom-sheet {
    top: ${({ showBreadcrumb, showTitle, hideHeader }) =>
      `${
        96 +
        (showBreadcrumb ? 36 : 0) +
        (showTitle ? 32 : 0) -
        (hideHeader ? 56 : 0)
      }px`};
  }
`;
